import React from "react";
import { Breadcrumb } from "@progress/kendo-react-layout";
import { useLocation, useNavigate } from "react-router";

export const Breadcrumbs = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const pathSegments = location.pathname.split("/").filter(Boolean);

    const breadcrumbItems = pathSegments.map((segment, index) => ({
        text: segment.replace(/-/g, " "),
        id: "/" + pathSegments.slice(0, index + 1).join("/"),
    }));

    const handleItemSelect = (e) => {
        if (e?.id && e.id !== location.pathname) {
            navigate(e.id);
        }
    };

    return (
            <Breadcrumb
                data={breadcrumbItems}
                onItemSelect={handleItemSelect}
                size={"small"}
            />

    );
};
